import { render, staticRenderFns } from "./ModalCadastroPessoa.vue?vue&type=template&id=c6ff4f38"
import script from "./ModalCadastroPessoa.vue?vue&type=script&lang=js"
export * from "./ModalCadastroPessoa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports